import {calculateRelatedScores, type Progress, type ProgressAggregates} from '@cp/model';
import subscribeProgressDoc from '../../api/progress/subscribeProgressDoc';
import {firebaseAuth} from '../../config/firebase';
import {useFunctionSubscribe} from '../helper/function/useFunctionSubscribe';

interface UseGetUserProgressOptions {
  examModuleId: string;
  skip?: boolean;
}

export default function useGetUserProgress(options: UseGetUserProgressOptions) {
  const {examModuleId, skip = false} = options;
  const uid = firebaseAuth.currentUser?.uid ?? null;
  const shouldSubscribe = !skip && !!examModuleId && !!uid;

  const {data, loading, error} = useFunctionSubscribe<Progress | undefined>(
    (onData, onError) => {
      if (!uid || !examModuleId) {
        onData(undefined);
        return () => {};
      }

      return subscribeProgressDoc(
        uid,
        examModuleId,
        (value) => {
          onData(value);
        },
        (err) => {
          console.error('useGetUserProgress: error subscribing to progress', err);
          onError(err);
        },
      );
    },
    {skip: !shouldSubscribe, deps: [uid, examModuleId]},
  );

  const progress: (Progress & ProgressAggregates) | undefined =
    skip || !data ? undefined : ({...data, ...calculateRelatedScores(data)} as Progress & ProgressAggregates);

  return {
    progress,
    loading,
    error: error ?? null,
    refetch: () => {},
  };
}
